var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.networkID === 1 ? [_c('v-alert', {
    staticClass: "testnet_alert mainnet_announcement",
    attrs: {
      "id": "mainnet_announce",
      "text": "",
      "rounded": "0"
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(" Explore network activity and staking metrics using "), _c('a', {
    staticClass: "bold",
    attrs: {
      "href": _vm.statsURL
    }
  }, [_vm._v("Avalanche Stats")]), _vm._v(". ")])])] : [_c('v-alert', {
    staticClass: "testnet_alert",
    attrs: {
      "text": "",
      "type": "info",
      "rounded": "0"
    }
  }, [_c('p', {
    staticClass: "description"
  }, [_vm._v(" Notice: This Explorer displays activity on the " + _vm._s(_vm.networkName) + " Testnet, "), _c('span', {
    staticClass: "bold"
  }, [_vm._v("not")]), _vm._v(" the Avalanche Mainnet. ")])])]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }